// extracted by mini-css-extract-plugin
export var btnBlock = "main-module--btn-block--f6261";
export var mainBtn = "main-module--main-btn--671dc";
export var mainTitle = "main-module--main-title--994a1";